exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/* Shadows are intentionally very subtle gradiations. */\n.PasswordField-passwordFieldContainer_2-LMq {\n  position: relative; }\n\n.PasswordField-passwordToggleIcon_1HFi9 {\n  position: absolute;\n  right: 0.3rem;\n  z-index: 101; }\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/PasswordField/PasswordField.scss"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa,EAAE","file":"PasswordField.scss","sourcesContent":["/* Shadows are intentionally very subtle gradiations. */\n.passwordFieldContainer {\n  position: relative; }\n\n.passwordToggleIcon {\n  position: absolute;\n  right: 0.3rem;\n  z-index: 101; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"passwordFieldContainer": "PasswordField-passwordFieldContainer_2-LMq",
	"passwordToggleIcon": "PasswordField-passwordToggleIcon_1HFi9"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]-[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./src/assets/scss/base.scss","./src/assets/scss/helpers.scss"]}!./src/components/PasswordField/PasswordField.scss
// module id = 1367
// module chunks = 0